/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import "./Frontend.css";
import { React, useEffect } from "react";
import create from "zustand";

import Submenu from "../components/Submenu";
import InfoPrompt from "../components/InfoPrompt";
import SideBar from "../components/SideBar";

const store = (set) => ({
  uiConfig: null,
  setUIConfig: (uiConfig) => set({ uiConfig }),
});

export const useButtonConfigStore = create(store);

function Frontend() {
  const uiConfig = useButtonConfigStore((state) => state.uiConfig);
  console.log("frontend rendering", uiConfig);
  // const skuInstanceId = "";
  return (
    uiConfig &&
    uiConfig.submenu === true && (
      <>
        <InfoPrompt />
        <div className="Frontend">
          <Submenu />
        </div>
        <SideBar />
      </>
    )
  );
}

// The main config exists in menu. Menu is an array to maintain ordering. Menus can be nested
// Alongside the menu, another key default stores the current selected one
// onClick action-> array of actions,
// each action is a Action object
// each object has type : "materials" | "clipAnimations" | "dynamicAnimations"
// each object will have config which will be passed to state

export default Frontend;
